import { Controller } from "stimulus";
import { Modal } from "bootstrap";

document.addEventListener('DOMContentLoaded', function() {
  const couponCodeInput = document.querySelector('[data-companies--purchases--new-target="couponCodeText"]');
  const applyButton = document.querySelector('#apply-coupon-button');

  if(couponCodeInput) {
    couponCodeInput.addEventListener('input', function() {
      applyButton.disabled = couponCodeInput.value.trim() === '';
    });
    couponCodeInput.addEventListener('keydown', function(e) {
      if(e.key === 'Enter') {
        e.preventDefault();
        applyButton.click();
      }
    });
  }
});

const packInputName = "company_purchase_form[pack_id]";
const paymentInputName = "company_purchase_form[payment_method]";

function notChecked(inputName) {
  return (
    document.querySelector('input[name="' + inputName + '"]:checked') == null
  );
}

function packInputCheck(packErrorMsg) {
  $('.discount-line').hide();
  var checked = true;
  if (notChecked(packInputName)) {
    checked = false;
    $(packErrorMsg).show();
  } else {
    $(packErrorMsg).hide();
  }
  return checked;
}

function paymentMethodInputCheck(paymentMethodErrorMsg) {
  var checked = true;
  if (notChecked(paymentInputName)) {
    $(paymentMethodErrorMsg).show();
    checked = false;
  } else {
    $(paymentMethodErrorMsg).hide();
  }
  return checked;
}

function allFieldsChecked(packErrorMsg, paymentMethodErrorMsg) {
  var packChecked = packInputCheck(packErrorMsg);
  var paymentChecked = paymentMethodInputCheck(paymentMethodErrorMsg);
  return packChecked && paymentChecked;
}

function addStrongHtml(value) {
  return "<strong>" + value + "</strong>";
}

export default class extends Controller {
  static targets = [
    "packErrorMsg",
    "paymentMethodErrorMsg",
    "packPriceBox",
    "placeOrderButton",
    "placeOrderButtonSidebar",
    "purchaseBillingFormErrorMsg",
    "purchaseBillingModal",
    "purchaseForm",
    "couponCode",
    "couponCodeText",
    "couponError",
    "packPrice",
    "discountPrice",
    "packVatPrice",
    "packTotalPrice",
    "discountDescription",
  ];

  connect() {
    this.selectedPack = null;
    this.checkFirstPaymentMethodIfNeeded();
    this.showAndSubmitBillingInformationModalForm();
  }

  checkFirstPaymentMethodIfNeeded() {
    if(notChecked(paymentInputName)) {
      const firstPaymentTypeSelector = `input[type='radio'][name='${paymentInputName}']`;
      const firstPaymentType = document.querySelectorAll(firstPaymentTypeSelector)[0];
      firstPaymentType.checked = true;
    }
  }

  packSelected(event) {
    packInputCheck(this.packErrorMsgTarget);
    var element = event.currentTarget;
    this.selectedPack = element;

    this.updatePriceBox(element);
  }

  updatePriceBox(element) {
    this.selectedPack = element;
    $($(this.packPriceBoxTarget).find("#pack-title")[0]).html(
      element.dataset.packTitle
    );
    $($(this.packPriceBoxTarget).find("#pack-vat")[0]).html(
      element.dataset.packVat
    );
    $($(this.packPriceBoxTarget).find("#pack-price")[0]).html(
      element.dataset.packPrice
    );
    if(this.selectedCoupon != null) {
      $($(this.packPriceBoxTarget).find("#discount-price")[0]).html(
        ""
      );
    }
    $($(this.packPriceBoxTarget).find("#pack-vat-price")[0]).html(
      addStrongHtml(element.dataset.packVatPrice)
    );
    $($(this.packPriceBoxTarget).find("#pack-total-price")[0]).html(
      addStrongHtml(element.dataset.packTotalPrice)
    );
    $(this.packPriceBoxTarget).show();
  }

  paymentMethodSelected(_event) {
    paymentMethodInputCheck(this.paymentMethodErrorMsgTarget);
  }

  place_order(event) {
    event.preventDefault();
    if (
      allFieldsChecked(
        this.packErrorMsgTarget,
        this.paymentMethodErrorMsgTarget
      )
    ) {
      this.purchaseFormTarget.requestSubmit();
      this.disableButtons();
    }
  }

  disableButtons() {
    this.placeOrderButtonTarget.classList.add("disabled");
    this.placeOrderButtonSidebarTarget.classList.add("disabled");
    this.showSpinner();
  }

  showSpinner() {
    const spinner = `<div class="d-flex justify-content-center" style="padding: 0.25rem 1.5rem;">
      <div class="spinner-border spinner-border-sm" role="status">
      <span class="visually-hidden">Loading...</span>
      </div>
      </div>`;

    this.placeOrderButtonTarget.innerHTML = spinner;
    this.placeOrderButtonSidebarTarget.innerHTML = spinner;
    this.disableProductInputs();
  }

  disableProductInputs() {
    const inputs = document.querySelectorAll(`input[name='${packInputName}']`);

    inputs.forEach((input) => {
      input.disabled = true;
    })
  }

  showAndSubmitBillingInformationModalForm() {
    const billingInfoValid = this.purchaseFormTarget.getAttribute('data-billing-info-valid');
    if(billingInfoValid === 'true' || billingInfoValid === null) {
      return;
    }

    const element = document.getElementById("billingInformation");
    if(element) {
      this.show(this.purchaseBillingFormErrorMsgTarget);
      new Modal(element).show();
    }
  }

  applyCoupon() {
    const packId = this.selectedPack.value;
    const couponCode = this.couponCodeTextTarget.value;
    const locale = window.location.pathname.split('/')[1];
    const localePath = locale === 'en' ? '/en' : '';

    const url = `${localePath}/employer/discounts/${couponCode}?pack_id=${packId}`;

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network error calling discounts');
        }
        return response.json()
      })
      .then(data => {
        const { valid, code, price, amount, vat, total_price, discount_description, message } = data;
        if (valid) {
          this.updateOnValidCoupon(code, price, amount, vat, total_price, discount_description);
        } else {
          this.updateOnInvalidCoupon(message);
        }

        this.resetCouponInput();
      })
      .catch(error => {
        console.error('Error during fetch:', error);
        this.updateOnInvalidCoupon('There was an error applying the coupon.');
    });
  }

  updateOnValidCoupon(code, price, amount, vat, total_price, discount_description) {
    this.couponCodeTarget.value = code;
    this.updatePriceBox(this.selectedPack);

    document.querySelectorAll('.discount-line').forEach(this.show);

    this.packPriceTarget.textContent = price;
    this.discountPriceTarget.textContent = amount;
    this.packVatPriceTarget.textContent = vat;
    this.packTotalPriceTarget.textContent = total_price;
    this.discountDescriptionTarget.textContent = discount_description;

    this.clearDiscountErrorMessage();
  }

  updateOnInvalidCoupon(message) {
    this.couponCodeTarget.value = null;
    this.updatePriceBox(this.selectedPack);
    this.showErrorMessage(message);

    document.querySelectorAll('.discount-line').forEach(this.hide);
  }

  showErrorMessage(message) {
    this.couponErrorTarget.textContent = message;
    this.show(this.couponErrorTarget);
  }

  clearDiscountErrorMessage() {
    this.couponErrorTarget.textContent = '';
    this.hide(this.couponErrorTarget);
  }

  resetCouponInput() {
    this.couponCodeTextTarget.value = '';
    this.couponCodeTextTarget.dispatchEvent(new Event('input', { bubbles: true }));
  }

  hide(element) {
    element.style.display = "none";
  }

  show(element) {
    element.style.display = "block";
  }
}
